import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { uploadFile } from './../../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import TemplateModel from '../../templateManage/templateModel.vue';
import { mainDetail, editMainTemplate } from './../request';
export default {
  props: ['id', 'info'],
  components: {
    topTitle,
    TemplateModel
  },
  data() {
    return {
      templateShow: false,
      action: uploadFile,
      fileList: [],
      dataFrom: {
        batchTemplate: ""
      },
      dataRule: {},
      list: this.info.rendering
    };
  },
  created() {
    setTimeout(() => {
      this.list = this.info.rendering;
      console.log(this.list);
      if (this.info.batchTemplate) {
        this.dataFrom.batchTemplate = this.info.batchTemplate;
        this.fileList = [{
          uid: '2',
          name: this.info.batchTemplateName,
          status: 'done',
          url: this.info.batchTemplate
        }];
      }
    }, 400);
  },
  methods: {
    handleChange(info) {
      let fileList = info.fileList;
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
      this.fileList = info.fileList.length != 0 ? [info.fileList[info.fileList.length - 1]] : [];
      this.dataFrom.batchTemplate = this.fileList.length != 0 ? this.fileList[0].url : '';
    },
    addFun() {
      this.templateShow = true;
      this.$nextTick(() => {
        this.$refs.templateFrom.init({
          type2: 'add'
        });
      });
    },
    processFun() {
      let arr = [];
      this.list.map(item => {
        item.item.map(item2 => {
          if (item2.selected) {
            arr.push(item2.id);
          }
        });
      });
      console.log(arr);
      // if(!this.dataFrom.batchTemplate){
      //     return false;
      // }
      if (arr.length == 0) {
        this.$message.error(this.$t('投保模版必须要选择'));
        return false;
      }
      this.dataFrom.insuranceId = this.id;
      this.dataFrom.rendering = arr.join(",");
      editMainTemplate(this.dataFrom).then(res => {
        // this.$message.success('成功!');
        this.$emit('next', res);
      });
    },
    infoFun() {
      mainDetail({
        insuranceId: this.id
      }).then(res => {
        this.list = res.rendering;
      });
    }
  }
};